/* eslint-disable complexity */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */
import React, { useState, useEffect, useMemo } from "react";
import styles from "./styles.css";
import { NUMBER } from "../../../constants/app-constants";
import PropTypes from "prop-types";
import { requestIdleCallbackPolyfill } from "../../../utils/helpers/request-idle-callback-polyfill";
import { bifrost } from "../../../utils/get-bifrost-instance";

const InputOTPSingular = ({
    isOTPInvalid,
    otpLength = bifrost.getOtpLength(),
    inputRef,
    errorMessage,
    placeholder = "0",
    prefilledOtp = null,
    onOTPVerifyCallback = () => { },
    onOTPInputCallback = () => { },
    onOtpChange,
    isLoading = false,
    isAutoFocus = false
}) => {
    const getDefaultOtp = useMemo(() => new Array(otpLength).fill(""), [otpLength]);
    const [otp, setOTP] = useState(getDefaultOtp);
    const [maxLength, setMaxLength] = useState(otpLength);

    useEffect(() => {
        if (inputRef && inputRef.current && isAutoFocus) {
            inputRef.current.focus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (otp && otp.length === otpLength && otp.every(value => (value || value === NUMBER.ZERO))) {
            onOTPVerifyCallback(otp.join(""));
            onOTPInputCallback(true);
        } else onOTPInputCallback(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [otp]);

    useEffect(() => {
        if (onOtpChange) onOtpChange(otp.join(""));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [otp]);

    useEffect(() => {
        if (prefilledOtp) {
            if (prefilledOtp.length === otpLength) {
                setOTP(`${prefilledOtp}`.split(""));
            }
        } else {
            setOTP(getDefaultOtp);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getDefaultOtp, otpLength, prefilledOtp]);

    const onOtpChangeHandler = (idx, event) => {
        if (idx === NUMBER.THREE) setMaxLength(NUMBER.ONE);
        const { value, nextSibling, previousSibling } = event.target;
        if (isNaN(value)) return;
        setOTP([...otp.map((otpNo, i) => i === idx ? value : otpNo)]);

        requestIdleCallbackPolyfill(() => {
            if (!value && previousSibling) {
                previousSibling.focus();
            }
            if (value && nextSibling) {
                // Condition for Chrome iOS
                if (value.length === otpLength && idx === 0) {
                    if (inputRef && inputRef.current) {
                        inputRef.current.blur();
                    }
                } else {
                    nextSibling.focus();
                }
            }
        });
    };

    return (
        <React.Fragment>
            <div styleName={"styles.otpGrid"}>
                <div style={{ gridTemplateColumns: `repeat(${otpLength}, 1fr)` }} styleName={`styles.otpInputWrap ${isOTPInvalid ? "styles.error" : ""} ${isLoading ? "styles.loading" : ""}`}>
                    {Array.isArray(otp) && otp.map((data, index) => (
                        <input
                            ref={index === 0 ? inputRef : null}
                            key={index}
                            type="tel"
                            placeholder={placeholder}
                            maxLength={maxLength}
                            value={data}
                            // eslint-disable-next-line no-invalid-this
                            onChange={onOtpChangeHandler.bind(this, index)}
                            onFocus={(e) => e.target.select()}
                            autoComplete="one-time-code"
                            className="shrinkOnTouch"
                        />
                    ))}
                </div>
                {isOTPInvalid && <p styleName={"styles.textError"}>{errorMessage || "Incorrect OTP, please try again."}</p>}
            </div>
        </React.Fragment>
    );
};

InputOTPSingular.propTypes = {
    isOTPInvalid: PropTypes.bool,
    autoOTPVerify: PropTypes.bool,
    maxResentCount: PropTypes.number,
    otpLength: PropTypes.number,
    errorMessage: PropTypes.string,
    onOTPVerifyCallback: PropTypes.func,
    resendOTP: PropTypes.func,
    onOTPInputCallback: PropTypes.func,
    onOtpChange: PropTypes.func,
    inputRef: PropTypes.object,
    prefilledOtp: PropTypes.any,
    isLoading: PropTypes.bool,
    isAutoFocus: PropTypes.bool,
    placeholder: PropTypes.string
};

export default InputOTPSingular;
